module.exports = __webpack_public_path__ + "static/img/code-3.34e5ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code-3.png
// module id = j6Lr
// module chunks = 13